import React from "react";

import { LinkItems } from "../../../../routes/Routes";
import { NavItem } from "../NavItem/NavItem";
import {
  IconButton,
  Box,
  CloseButton,
  Flex,
  Center,
  useColorModeValue,
  Drawer,
  DrawerContent,
  Text,
  useDisclosure,
} from "@chakra-ui/react";
import { Outlet } from "react-router-dom";
import { useParams } from "react-router-dom";
import { SignOut } from "../../../Auth/components/SignOut/SignOut";
import { useUserInfo } from "../../../../shared/hooks/useUserInfo";
import { FiMenu } from "react-icons/fi";
const bgColor = "#f9f9f9";

export default function SideBarWrapper() {
  const [userInfo] = useUserInfo();
  const { isOpen, onOpen, onClose } = useDisclosure();
  return (
    <Box
      minH="100vh"
      maxH={"100vh"}
      overflowY="scroll"
      // bg={useColorModeValue("gray.100", "black.900")}
      bg={bgColor}
    >
      <SidebarContent
        onClose={() => onClose}
        companyId={(userInfo as any)?.tenantId}
        display={{ base: "none", md: "none", lg: "block" }}
      />
      <Drawer
        autoFocus={false}
        isOpen={isOpen}
        placement="left"
        onClose={onClose}
        returnFocusOnClose={false}
        onOverlayClick={onClose}
        size="full"
      >
        <DrawerContent>
          <SidebarContent
            companyId={(userInfo as any)?.tenantId}
            onClose={onClose}
          />
        </DrawerContent>
      </Drawer>

      {/* mobilenav */}
      <MobileNav
        display={{ base: "flex", md: "flex", lg: "none" }}
        onOpen={onOpen}
      />

      <Center ml={{ base: 0, lg: 60 }} p="2">
        {/* React Router Dom <Outlet/>
          https://reactrouter.com/docs/en/v6/getting-started/tutorial
          */}
        <Outlet />
      </Center>
    </Box>
  );
}

const SidebarContent = ({ onClose, companyId, ...rest }) => {
  console.log("companyId", companyId);
  return (
    <Box
      bg={bgColor}
      // borderRightColor="#F3F3F1"
      // borderRight="1px"
      color="#11264b"
      w={{ base: "full", lg: 60 }}
      pos="fixed"
      h="full"
      {...rest}
    >
      {/* <Text
        fontSize="2xl"
        fontFamily="monospace"
        fontWeight="bold"
        margin="20px"
        display={{ base: "none", md: "flex", lg: "flex" }}
      >
        TellStory
      </Text> */}
      <Box
        shadow={"lg"}
        // marginY="20px"
        bg="#000"
        color="white"
        // borderRadius="0 15px 15px 0"
        height="100vh"
      >
        <Flex
          h="20"
          alignItems="center"
          mx="8"
          justifyContent="space-between"
          // display={{ base: "flex", md: "none", lg: "none" }}
        >
          <Text mt="4" fontSize="2xl" fontFamily="monospace" fontWeight="bold">
            TellStory
          </Text>
          <CloseButton
            display={{ base: "flex", lg: "none" }}
            onClick={onClose}
          />
        </Flex>
        {/* <Flex h="5" /> */}
        {LinkItems.map((link) => (
          <NavItem
            closeFn={onClose}
            linkTo={`${companyId}/${link.name}`}
            key={link.name}
            pathname={link.name.toLowerCase()}
            icon={link.icon}
          >
            {link.name}
          </NavItem>
        ))}
        <Box p="4" mx="4">
          <SignOut />
        </Box>
      </Box>
    </Box>
  );
};

const MobileNav = ({ onOpen, ...rest }) => {
  return (
    <Flex
      ml={{ sm: 0, md: 0, lg: 60 }}
      px={{ base: 4, md: 24 }}
      height="20"
      alignItems="center"
      bg="#000"
      borderBottomWidth="1px"
      borderBottomColor="#004040"
      justifyContent="flex-start"
      {...rest}
    >
      <IconButton
        variant="outline"
        onClick={onOpen}
        aria-label="open menu"
        color={"white"}
        icon={<FiMenu />}
      />

      {/* <Text fontSize="2xl" ml="8" fontFamily="monospace" fontWeight="bold">
        Logo
      </Text> */}
    </Flex>
  );
};
